export default __webpack_public_path__ + "static/PromptIconEleven-fdbd8392067e648a2b6aaba09402c134.png";